import React from "react";
import "./index.scss";
import {Image} from "react-bootstrap";

const appLogo = require("./assest/logo512.png");
const vectorImage = require("./assest/vector-removebg-preview.png");
const e_nama_img = require("../../../assets/images/enamad-1.png")

type Props = {};

const HomeScreen = (props: Props) => {
  function menu() {
    const menuBtn = document.querySelector("#menuBtn");
    const navLinks = document.querySelector(".nav-links");
    console.log(menuBtn);
    menuBtn?.addEventListener("click", () => {
      navLinks?.classList.toggle("mobile-menu");
    });
  }

  return (
    <div>
      <section className="header" dir="ltr">
        <header>
          <img className="logo" src={appLogo} alt="appLogo" />
          <ul className="nav-links" dir="rtl">
            <li>
              <a href="/panel/login">
                <i className="fa-solid fa-right-to-bracket my-custom-icon"></i>
                ورود به سامانه
              </a>
            </li>
            <li>
              <a href="/panel/register">
                <i className="fa-solid fa-user-plus my-custom-icon"></i>
                ثبت نام
              </a>
            </li>
            {/*<li>*/}
            {/*  <a href="/driver/verify">*/}
            {/*    <i className="ri-customer-service-2-fill"></i>*/}
            {/*    رانندگان*/}
            {/*  </a>*/}
            {/*</li>*/}
          </ul>
          <div id="menuBtn" onClick={menu}>
            <i className="fa-solid fa-bars"></i>
          </div>
        </header>
        {/* <nav>
          <ul>
            <li>مقالات</li>
            <li>ارسال پیام</li>
            <li>تماس برخط</li>
            <li>توسعه دهندگان</li>
          </ul>
        </nav> */}
        <div className="content-header">
          <h1>سنجد:پلتفرم هوشمند سرویس مدارس</h1>
          <br />
          <br />
          <br />
          {/* <p>با ارائه سرویس های خود به شما امنیت فرزندانتان را تضمین میکنیم</p> */}
        </div>
      </section>
      <section className="slideshow">
        <div id="demo" className="carousel slide" data-ride="carousel">
          <ul className="carousel-indicators">
            <li data-target="#demo" data-slide-to="0" className="active"></li>
            <li data-target="#demo" data-slide-to="1"></li>
            <li data-target="#demo" data-slide-to="2"></li>
            <li data-target="#demo" data-slide-to="2"></li>
            <li data-target="#demo" data-slide-to="2"></li>
          </ul>

          {/* <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="./assest/Sunset.jpg" alt="Los Angeles" width="800" height="700" />
            </div>
            <div className="carousel-item">
              <img src="./assest/slider.jpg" alt="Chicago" width="700" height="300" />
            </div>
            <div className="carousel-item">
              <img src="./assest/Road asphalt by Luca Micheli [2160x3840].jpg" alt="New York" width="700" height="300" />
            </div>
            <div className="carousel-item">
              <img src="./assest/Road asphalt by Luca Micheli [2160x3840].jpg" alt="New York" width="700" height="300" />
            </div>
            <div className="carousel-item">
              <img src="./assest/Road asphalt by Luca Micheli [2160x3840].jpg" alt="New York" width="700" height="300" />
            </div>
          </div> */}

          <a className="carousel-control-prev" href="#demo" data-slide="prev">
            <span className="carousel-control-prev-icon"></span>
          </a>
          <a className="carousel-control-next" href="#demo" data-slide="next">
            <span className="carousel-control-next-icon"></span>
          </a>
        </div>
      </section>
      <div>
        {/* <h2 className="header-content">چرا سنجد</h2> */}
        <div className="content-cd">
          {/* <div className="left-side-2">
            <img className="image" src={vectorImage} alt="vectorImage" />
          </div> */}
          <div className="right-side-2">
            <h3 className="header-body">سنجد چیست؟</h3>
            <p className="text-body">
              پلتفرم هوشمند سرویس مدارس یکی از پلتفرم‌های نو و کارآمد است که در جهت افزایش امنیت دانش‌آموزان در مسیر رفت و برگشت مدارس و استفاده از
              سرویس ایجاد شده است. از جمله مهم‌ترین دغدغه خانواده‌هایی که فرزند دانش‌آموز دارند، رفت و برگشت وی از خانه به مدرسه و بالعکس است. در
              صورتی که مسیر خانه به مدرسه کوتاه باشد، دانش‌آموز می‌تواند به تنهایی یا همراه با والدین این مسیر را پیاده طی کند. اما در غیر این صورت
              باید از وسایل نقلیه استفاده شود که بهترین حالت استفاده از سرویس مدارس است. مهم‌ترین خدمتی که والدین با استفاده از پلتفرم سرویس مدارس
              دریافت می‌کنند، امکان اطلاع از وضعیت دقیق فرزندشان در مسیر رفت و برگشت مدارس بطور لحظه‌ای است. در نتیجه نسبت به این موضوع آسوده‌خاطر
              بوده و در صورت هرگونه تغییر مسیر و یا مشکل، می‌توانند در اسرع وقت اقدامات لازم را انجام دهند. لازم به ذکر است که خدمات این پلتفرم تنها
              برای والدین نیست، بلکه به شهرداری ها، آموزش و پرورش، مدارس، شرکت‌ها و رانندگان هم ارائه می‌شود که برای هر یک ارزش‌هایی را خلق خواهد کرد.
              بطورکلی این پلتفرم به اولیا دانش آموزان کمک می کند تا بصورت آنلاین نزدیک شدن , سوار شدن و پیاده شدن دانش آموز خود را روی گوشی خود ببینند
              و همچنین امکان نظارت پیمانکاران و مدیران مدارس را افزایش می دهد.
            </p>
          </div>
        </div>
        <div className="content-cd" dir="ltr">
          {/* <div className="left-side-2">
            <img className="image" src={vectorImage} alt="vectorImage" />
          </div> */}
          <div className="right-side-2">
            <h3 className="header-body">چرا سنجد؟</h3>
            <p className="text-body">
              : دسترسی آسان و کارایی بهتر <br />
              یکی از اصلی‌ترین دغدغه‌ها برای سرویس دانش آموزان، زمان سوار شدن و پیاده شدن دانش آموزان است. در روش سنتی اولیا دانش آموزان و رانندگان در
              گرما و سرما بدون اطلاع قبلی باید منتظر بمانند. با وجود سنجد دیگر مشکلی در زمانبندی وجود نخواهد داشت و به صورن آنلاین اولیا و راننده
              یکدیگر را رصد خواهند کرد و از زمان نزدیک شدن و شوار شدن و پیاده شدن به طور لحظه ای اطلاع خواهند داشت.
            </p>
            <p className="text-body">
              : سریع و صرفه جویی در زمان <br />
              یکی دیگر از مهمترین مزیت هایی که سنجد می تواند برای مخاطبین خود داشته باشد بحث سرعت و صرفه جویی در زمان است. با وجود آنلاین بودن این
              پلتفرم و نمایش رانندگان و دانش آموزان بر روی نقشه و مشاهده و اطلاع از آن زمان کمتری صرف انتظار کشیده می شود.
            </p>
            <p className="text-body">
              : دوستدار محیط زیست <br />
              محیط زیست، مهمترین و شاید نگران‌کننده‌ترین بعد زندگی ما انسان‌هاست که باید در هر قدم از فعالیت‌های خود به آن به صورت ویژه توجه کنیم. یکی
              از اهداف اصلی سنجد کاهش تولید آلایندگی در سطح شهرهاست؛ به این صورت که با مدیریت و کمتر کردن مسافت طی‌شده برای رساندن دانش آموزان، مصرف
              سوخت را تا حد زیادی کاهش می‌دهند.
            </p>

            <p className="text-body">
              : امنیت <br />
              از دیگر دغدغه های اولیا نگرانی از سلامت و امنیت فرزندان خود است که با وجود سنجد و با توجه به اساس این پلتفرم، چنین نگرانی هایی دیگر وجود
              نخواهد داشت و بطور لحظه ای از حضور یا عدم حضور و همینطور رسیدن یا نرسیدن دانش آموز خود به مدرسه و منزل مطلع خواهند شد.
            </p>
          </div>
        </div>
      </div>
      <div className="content-download">
        <div className="text">
          <h3>لینک دریافت نرم افزار اولیا</h3>
        </div>
        <div className="link-download">
          {/* <!-- <a href="#">
          <img className="cafe-bazaar" src="assest/cafebazar.png" alt="link download" />
        </a>
        <a href="#">
          <img className="google-play" src="assest/googleplay.png" alt="link download" />
        </a>
        <a href="#">
          <img className="myket" src="assest/myket.png" alt="link myket" />
        </a> --> */}
          <a href="https://cafebazaar.ir/app/com.app.parent?ref=share" download>
            <img className="cafe-bazaar" src={require("./assest/cafebazar.png")} alt="link download" />
          </a>
        </div>
        <div className="text2">
          <h3>لینک دریافت نرم افزار راننده</h3>
        </div>
        <div className="link-download">
          {/* <!-- <a href="#">
        </a>
        <a href="#">
          <img className="google-play" src="assest/googleplay.png" alt="link download" />
        </a>
        <a href="#">
          <img className="myket" src="assest/myket.png" alt="link myket" />
        </a> --> */}
          <a href="https://cafebazaar.ir/app/?id=com.service.driver&ref=share" download>
          <img className="cafe-bazaar" src={require("./assest/cafebazar.png")} alt="link download" />
          </a>
        </div>
      </div>
      <section className="footer">
        <div className="container my-5">
          <footer className="text-center text-white">
            <div className="container" id="#footer">
              <div
                  id="e_nama"

              >

              <a className="a-e-nama" referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=404299&Code=b7f3rnnFym7ehUMPJ2UoWlRPM3Jevrw9">
                <Image
                    className="img-e-nama"
                    referrerPolicy="origin"
                    src={e_nama_img}
                    alt=""
                    data-code="b7f3rnnFym7ehUMPJ2UoWlRPM3Jevrw9"
                />
              </a>
              </div>

              {/* <section className="mt-5">
                <div className="row text-center d-flex justify-content-center pt-5">
                  <div className="col-md-2">
                    <h6 className="text-uppercase font-weight-bold">
                      <a href="#!" className="text-white">
                        درباره ما
                      </a>
                    </h6>
                  </div>
                  <div className="col-md-2">
                    <h6 className="text-uppercase font-weight-bold">
                      <a href="#!" className="text-white">
                        توسعه دهنده
                      </a>
                    </h6>
                  </div>
                  <div className="col-md-2">
                    <h6 className="text-uppercase font-weight-bold">
                      <a href="#!" className="text-white">
                        مقالات
                      </a>
                    </h6>
                  </div>
                  <div className="col-md-2">
                    <h6 className="text-uppercase font-weight-bold">
                      <a href="#!" className="text-white">
                        کمک
                      </a>
                    </h6>
                  </div>

                  <div className="col-md-2">
                    <h6 className="text-uppercase font-weight-bold">
                      <a href="#!" className="text-white">
                        پشتیبانی
                      </a>
                    </h6>
                  </div>
                </div>
              </section> */}

              <hr className="my-5" />

              <section className="mb-5">
                <div className="row d-flex justify-content-center">
                  <div className="col-lg-8">
                    <p>سنجد پلتفرم پیشرو و بروز در سرویس مدارس با امنیت کامل فرزندتان را به ما بسپارید</p>
                  </div>
                </div>
              </section>

              {/* <section className="text-center mb-5">
                <a href="" className="text-white me-4">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="" className="text-white me-4">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="" className="text-white me-4">
                  <i className="fab fa-google"></i>
                </a>
                <a href="" className="text-white me-4">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="" className="text-white me-4">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://github.com/mohammadasadiyan" className="text-white me-4">
                  <i className="fab fa-github"></i>
                </a>
              </section> */}
            </div>
          </footer>
        </div>
      </section>
    </div>
  );
};

export default HomeScreen;
